module.exports = __webpack_public_path__ + "img/zlsc.fdb76884.png";